"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var setInitialFocus = function setInitialFocus(initialFocusId) {
  if (!initialFocusId) return;
  var targetElement = document.getElementById(initialFocusId);

  if (targetElement) {
    setTimeout(function () {
      targetElement.focus();
    });
  }
};

var _default = setInitialFocus;
exports["default"] = _default;
//# sourceMappingURL=setInitialFocus.js.map